export default "__VITE_PUBLIC_ASSET__a19d35ae__"